export default "__VITE_ASSET__VeVPoutJ__"